import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { ApiStatus } from "commonModule/services/common"

//------------------- UPDATE PRICE DROP ALERT APIS ----------------
export interface PriceDropAlertRequestData {
  checkInDate: string
  checkOutDate: string
  propertyId: string | null // This is required if price drop is for property
  adults: number
  children: number
  petsAllowed: boolean
  petNumber?: number
  propertyPrice: number | null // This is required for property based price drop alert
  locationName: string | null // required for location based price drop alert
  priceDropAlertId: string | null // If it is existing price drop alert then id should be passed to update/disable the price drop alert flag.
  isPriceDropAlertEnabled: boolean // If price drop alert is enabled or not
  noOfNights: number
  searchRequestData: {
    // This is required for location based price drop alert
    bounds: string | null
    lat: number | null
    lng: number | null
    isPolygonSearch: boolean | null
    isNearBySearch?: boolean | null
  } | null
}

export interface PriceDropAlertRequest extends Partial<AxiosRequestConfig> {
  data: PriceDropAlertRequestData
}

export interface PriceDropAlertResponse extends AxiosResponse {
  data: {
    errorCode: number
    errorMessage: string
    apiStatus: string
    message: string
    data: string
  }
}

export function createUpdatePriceDropAlertApi(
  { data }: PriceDropAlertRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    data,
    method: "post",
    url: "/user/price-drop-alert",
  }) as Promise<PriceDropAlertResponse>
}

//------------------- GET PRICE DROP ALERT APIS ----------------

export interface PriceDropAlertType extends AxiosResponse {
  propertyName: string
  city: string
  state: string
  country: string
  originalPrice: number
  currentPrice: number
  adultsCount: number
  propertyImageUrl: string
  checkInDate: string // e.g., "2025-08-01"
  checkOutDate: string // e.g., "2025-08-02"
  childrenCount: number
  id: string
  propertyId: string
  isPolygonSearch: boolean
  isPriceDrop: boolean
  petsAllowed: boolean
  petNumber?: number
  priceDropPropertiesCount: number
  searchLocation: string
  totalPropertiesMonitored: number
  type: string // literal type if it’s always "LOCATION" or "PROPERTY"
  searchRequestData?: {
    bounds: string | null
    lat: number | null
    lng: number | null
    isPolygonSearch: boolean | null
  }
  locationHeroImgUrls?: string[] | null
}

export interface PriceDropAlertResponseData extends AxiosResponse {
  data: PriceDropAlertType[]
}

export interface GetPriceDropAlertResponse extends AxiosResponse {
  data: PriceDropAlertResponseData
}
export function getPriceDropAlertApi(axiosInstance: AxiosInstance) {
  return axiosInstance({
    method: "get",
    url: "/user/price-drop-alert",
  }) as Promise<GetPriceDropAlertResponse>
}

//-------------- fetch property id based get price drop alert data api ---------------

export interface PriceDropPropertiesType {
  propertyId: string
  propertyImageUrl: string
  propertyName: string
  currentPrice: number
  oldPrice: number
  pviScore: string
  propertyTypeDesc?: string
  city?: string
  state?: string
  country?: string
  noOfGuest?: number
  noOfBedroom?: number
  noOfNight?: number
  checkInDate?: string
  checkOutDate?: string
  pricePerNight?: number | string
  adultsCount?: number
  childrenCount?: number
  petsAllowed?: boolean
  petNumber?: number
}

export interface PropertyIdBasedPriceDropAlertType extends AxiosResponse {
  id: string
  isPolygonSearch: boolean
  isPriceDrop: boolean
  petsAllowed: boolean
  priceDropProperties: PriceDropPropertiesType[]
  totalPriceDropAmount: number
  type: string // literal type if it’s always "LOCATION"
}

export interface PropertyIdBasedPriceDropAlertResponseData
  extends AxiosResponse {
  data: PropertyIdBasedPriceDropAlertType
  apiStatus: ApiStatus
  errorMessage: string
}

export interface PropertyIdBasedPriceDropAlertResponse extends AxiosResponse {
  data: PropertyIdBasedPriceDropAlertResponseData
}

export interface PropertyIdBasedPriceDropAlertRequest
  extends Partial<AxiosRequestConfig> {
  alertId: string
}

export function getPropertyIdBasedPriceDropAlertApi(
  { alertId }: PropertyIdBasedPriceDropAlertRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method: "get",
    url: `/user/price-drop-alert/${alertId}`,
  }) as Promise<PropertyIdBasedPriceDropAlertResponse>
}

//-------------------------price drop alert notification api --------
export interface PriceDropAlertNotificationData extends AxiosResponse {
  data: boolean
}

export interface PriceDropAlertNotificationResponse extends AxiosResponse {
  data: PriceDropAlertNotificationData
}

export function getPriceDropAlertNotificationApi(axiosInstance: AxiosInstance) {
  return axiosInstance({
    method: "get",
    url: `/user/price-drop-alert/notification`,
  }) as Promise<PriceDropAlertNotificationResponse>
}

export interface PriceDropAlertReadNotificationResponse extends AxiosResponse {
  data: unknown
}
export interface PriceDropAlertReadNotificationRequest
  extends Partial<AxiosRequestConfig> {
  params: { isReadAll: boolean }
}

export function priceDropAlertReadNotificationApi(
  { params }: PriceDropAlertReadNotificationRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    params,
    method: "put",
    url: `/user/price-drop-alert/read`,
  }) as Promise<PriceDropAlertReadNotificationResponse>
}
